import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight
} from "@fortawesome/pro-solid-svg-icons";
import Paginate from "rc-pagination";

import type { PaginationProps } from "./pagination.types";

import s from "./pagination.module.scss";

const Pagination = ({
  pageCount,
  onPageChange,
  forcePage,
  current,
  showLessItems,
  colors
}: PaginationProps) => {
  const { paginationColor, iconColor } = colors || {};

  const buttonItemRender = (current: number, type: string) => {
    if (type === "prev") {
      return (
        <button type="button" data-testid="Previous page" title="Anterior">
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
      );
    }
    if (type === "next") {
      return (
        <button type="button" data-testid="Next page" title="Próximo">
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
      );
    }
    if (type === "jump-next" || type === "jump-prev") {
      return <button type="button">...</button>;
    }
    return <button type="button">{current}</button>;
  };

  return (
    <div
      className={s.pagination}
      style={
        {
          "--pagination-color": paginationColor,
          "--icon-color": iconColor
        } as React.CSSProperties
      }
    >
      <Paginate
        defaultCurrent={forcePage || undefined}
        total={pageCount * 12}
        defaultPageSize={12}
        onChange={onPageChange}
        current={current}
        itemRender={buttonItemRender}
        showLessItems={showLessItems}
      />
    </div>
  );
};

export default Pagination;
